module.exports = __webpack_public_path__ + "img/09.21c455ba.gif";